import instance from "../utils.ts/instance"

const cors = require('cors')
export const excuteAxiosPost = async (url: string, params: any) => {
    return await 
        instance.post(
            url, params
        )
}